import { dropdownBaseDriverFactory as publicDriverFactory } from './DropdownBase.uni.driver';
import { dropdownLayoutDriverFactory } from '../DropdownLayout/DropdownLayout.uni.driver';
import { UniDriver } from '@wix/wix-ui-test-utils/dist/types/unidriver';
import { KeyboardKey } from '@wix/unidriver-core';

export const dropdownBasePrivateDriverFactory = (
  base: UniDriver,
  body: UniDriver,
) => {
  const byDataHook = (dataHook: string) => body.$(`[data-hook="${dataHook}"]`);

  const getDataHook = async () => base.attr('data-hook');

  const getTargetElement = async () => {
    const dataHook = await getDataHook();
    return byDataHook(`${dataHook}-trigger`);
  };

  const getContentElement = async () => {
    const dataHook = await getDataHook();
    return byDataHook(`${dataHook}-content`);
  };

  const createDropdownLayoutDriver = () =>
    dropdownLayoutDriverFactory(base, body);

  return {
    ...publicDriverFactory(base, body),

    /** Returns the native target element */
    getTargetElement: async () => (await getTargetElement()).getNative(),

    /** Returns the native DropdownLayout element */
    getDropdownElement: async () => (await getContentElement()).getNative(),

    /** Return `true` if the option is hovered by the mouse */
    isOptionHovered: async (index: number) =>
      createDropdownLayoutDriver().isOptionHovered(index),

    /** Return `true` if the option is selected */
    isOptionSelected: async (index: number) =>
      createDropdownLayoutDriver().isOptionSelected(index),

    /** Trigger a keyDown event on the target element */
    keyDown: async (key: KeyboardKey) =>
      (await getTargetElement()).pressKey(key),

    /** Perform a mouseLeave on the target element */
    mouseLeaveTarget: async () => (await getTargetElement()).mouse.leave(),

    getDropdownLayoutDriver: createDropdownLayoutDriver,

    keyDownListItem: async (position: number, key: string) =>
      createDropdownLayoutDriver().keyDownListItem(position, key),

    isListItemFocused: async (position: number) =>
      createDropdownLayoutDriver().isListItemFocused(position),
  };
};
